export default function LoadingPage() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen overflow-hidden bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
      <div className="absolute w-[600px] h-[600px] bg-purple-600/20 rounded-full blur-3xl top-[-200px] left-[-200px] animate-pulse"></div>
      <div className="absolute w-[500px] h-[500px] bg-indigo-500/20 rounded-full blur-3xl bottom-[-200px] right-[-200px] animate-pulse"></div>

      <div className="relative flex items-center justify-center">
        <div className="w-20 h-20 border-[6px] border-purple-400/40 border-t-purple-500 rounded-full animate-spin"></div>
      </div>

      <p className="mt-8 text-xl md:text-2xl font-light tracking-wide text-gray-300 animate-fade-in">
        Loading your experience...
      </p>
    </div>
  );
}
